// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1LJXQ","radioRow":"SimpleQuestionBuilderModal_radioRow__1OjWQ"};